import React from 'react';
import { BarChart3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="bg-white/90 backdrop-blur-md shadow-lg border-b border-white/20 sticky top-0 z-40">
      <div className="container mx-auto py-2 sm:py-3 px-2 sm:px-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* <div className="p-3 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl shadow-lg">
              <AlertTriangle className="h-7 w-7 text-white" />
            </div> */}
            <div>
              {/* <h1 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                Customer Complaints Management
              </h1>
              <p className="text-gray-600 text-sm font-medium">
                Submit and track your product complaints efficiently
              </p> */}
            </div>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="flex items-center space-x-1.5 sm:space-x-2 px-3 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold text-xs sm:text-base rounded-lg sm:rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              <BarChart3 className="h-4 w-4 sm:h-5 sm:w-5" />
              <span>Dashboard</span>
            </button>
            {/* <div className="hidden md:flex items-center space-x-2 text-sm text-gray-500">
              <Shield className="h-4 w-4" />
              <span>Secure & Confidential</span>
            </div> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;